// extracted by mini-css-extract-plugin
export default {"containerBtn":"styles-scoped__containerBtn--Rw9Xx","btn":"styles-scoped__btn--cU9SE","error-icon":"styles-scoped__error-icon--ZvtbM","errorIcon":"styles-scoped__error-icon--ZvtbM"};